import { FC, ReactNode } from 'react';
import * as S from './styles';

export type AlertLevel = S.AlertLevel;
interface Props {
  title?: string;
  level: 'warning' | 'danger';
  children?: ReactNode;
}

export const Alert: FC<Props> = ({ title, level, children }) => {
  return (
    <S.Wrapper $level={level} data-testid="alert-wrapper">
      {title !== undefined && <S.Title data-testid="alert-title">{title}</S.Title>}
      <div dir="auto">{children}</div>
    </S.Wrapper>
  );
};
